<div class="input-group">
  <ng-content select="[input]"></ng-content>
  <div class="input-group-button">
    <button
      type="button"
      class="button button--icon-on-right secondary button--icon-on-right--done"
      (click)="doneButtonClicked()"
      [disabled]="disableDoneButton"
      [ngClass]="language === 'cy' ? 'wales' : ''"
    >
      <span data-test="mono-common-input-with-done-button-done-button-text">{{ doneText | async }}</span>
      <svg
        class="icon icon--checkmark icon--light"
        viewBox="0 0 24 24"
        width="150"
        height="150"
      >
        <use
          xlink:href="#icon-checkmark"
          href="#icon-checkmark"
        ></use>
      </svg>
    </button>
  </div>
</div>